import React from 'react'
import { Container, Grid, Icon } from 'semantic-ui-react'


const LeftCol1 = ({label,icon}) => (
  <Grid.Column width={1}><Icon name={icon}/></Grid.Column>
)

const LeftCol2 = ({label,icon}) => (
  <Grid.Column width={4}>{label}</Grid.Column>
)

const RightCol = ({href, label}) => (
  <Grid.Column width={10}>
    <a href={href} target='_blank' rel="noopener noreferrer">{label}</a>
  </Grid.Column>
)

const contact = () => (
  <Container>
    <div style={{maxWidth: '360px'}}>
      <h1 style={{paddingBottom: '20px'}}>Contact</h1>
      <Grid>
        <Grid.Row>
          <LeftCol1 icon='mail'/>
          <LeftCol2 label='email' />
          <RightCol href='mailto:timbrooke@hotmail.com' label='timbrooke@hotmail.com'/>
        </Grid.Row>
        <Grid.Row>
          <LeftCol1 icon='linkedin square'/>
          <LeftCol2 label='linkedin' />
          <RightCol href='https://www.linkedin.com/in/timbrooke/' label='www.linkedin.com/in/timbrooke'/>
        </Grid.Row>
        <Grid.Row>
          <LeftCol1 icon='twitter'/>
          <LeftCol2 label='twitter' />
          <RightCol href='https://twitter.com/timtwit' label='@timtwit'/>
        </Grid.Row>
        <Grid.Row>
          <LeftCol1 icon='github square'/>
          <LeftCol2 label='github' />
          <RightCol href="https://github.com/timbrooke" label='github.com/timbrooke'/>
        </Grid.Row>
      </Grid>
    </div>
  </Container>
)

export default contact



// WEBPACK FOOTER //
// ./src/modules/contact/Contact.js